// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const letterSpacings = {
  mega: '-0.01em',
  heading: '0em',
  body: '0em',
  bodyS: '0em',
  label: '0em',
  labelS: '0.06em',
  button: '0.06em',
  buttonS: '0.02em'
} as const;

export default letterSpacings;
